export { HTMLText } from './HTMLText'
export { HTMLTextData } from './data/HTMLTextData'

import { Plugin } from '@leafer-ui/draw'

Plugin.add('html')